module.exports = __webpack_public_path__ + "static/img/visual.4addc67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/proyectos_comerciales_secciones/visual.jpg
// module id = Nao5
// module chunks = 1